import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PartnerProfessionService } from './partner-profession.service';
import { PartnerProfession } from './partner-profession.interface';
const service = new PartnerProfessionService();

export interface PartnerProfessionState {
   partnerProfessions: Array<PartnerProfession>;
}

const PartnerProfessionStore: Module<PartnerProfessionState, StoreState> = {
   namespaced: true,
   state: {
      partnerProfessions: [],
   },
   getters: {},
   mutations: {
      SET_PARTNER_PROFESSIONS(state, partnerProfessions: Array<PartnerProfession>) {
         state.partnerProfessions = partnerProfessions;
      },
   },
   actions: {
      async getPartnerProfessions({ commit }) {
         return await service.getPartnerProfessions().then((response) => {
            commit('SET_PARTNER_PROFESSIONS', response.data);
            return response.data;
         });
      },
   },
};

export default PartnerProfessionStore;
